import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SvgIconComponent } from '@ngneat/svg-icon';
import { RichTextDirective } from '@libs/ui-lib';

/** The purple welcome card of the assistant chat. The description is Markdown, sanitized on render. */
@Component({
  selector: 'lib-assistant-welcome-banner',
  standalone: true,
  imports: [SvgIconComponent, RichTextDirective],
  templateUrl: './assistant-welcome-banner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssistantWelcomeBannerComponent {
  public readonly title = input.required<string>();
  public readonly description = input.required<string>();
}
